import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { Icon } from '../../../subcomponents/icon/icon';
const b = bemClassBuilder('v-site-picker-empty-list-message');
export const SitePickerEmptyListMessage = observer(props => {
    const i18n = useI18n();
    const { searchTerm, displayText, assets } = props;
    return (_jsxs("div", { className: b.block(), children: [_jsx(Icon, { className: b.element('icon'), name: assets.noSitesFoundIconName }), _jsx("p", { className: b.element('description'), children: getFormattedDescription(displayText, searchTerm, i18n) })] }));
});
SitePickerEmptyListMessage.displayName = 'SitePickerEmptyListMessage';
const getFormattedDescription = (displayText, searchTerm, i18n) => {
    return i18n.template(displayText.noSitesFoundForSearchTermMessage, { searchTerm });
};
//# sourceMappingURL=empty-list-message.js.map